import React from 'react';
import Rest from '../../../../helpers/Rest';

const CONTEXT = React.createContext(null);

export function useDocuments(){
    const context = React.useContext(CONTEXT);
    if (!context){
        throw new Error("useDocuments must be used within a DocumentsProvider")
    }
    return context
}

export function DocumentsProvider({children, deviceId}){
    const [documents, setDocuments] = React.useState(null);

    React.useEffect(() => {
        if (deviceId){
            Rest.get(`documents/${deviceId}`).then(setDocuments)
        }
    }, [deviceId])

    return <CONTEXT.Provider value={{documents, setDocuments}}>
        {children}
    </CONTEXT.Provider>
}